<template>
  <div>
    <br />
    
    

    <hr />
    <h5>Articles</h5>
    <form @submit.prevent="handleFormSubmit()">
      <div class="row align-items-end">
        <div class="col-xl-3 col-12 my-3">
          <label for="">Catégorie</label>
          <vue-select
            :options="sections"
            v-model="section_reference"
            placeholder="Select an option"
            labelColumn="fullName"
            valueColumn="reference"
          />
        </div>

        <div class="col-xl-4 col-12 my-3">
          <label for="itemInput">Produit</label>
          <vue-select
            :options="filteredItems"
            v-model="saleItem.item_reference"
            placeholder="Select an option"
            labelColumn="fullName"
            valueColumn="reference"
          />
        </div>

        <div v-if="shouldShowStockQuantity" class="col-xl-2 col-12 my-3">
          <label for="">Stock disponible</label>
          <input
            :value="
              availableStockQuantity !== null
                ? availableStockQuantity +
                  (selectedItemMeasuring ? ' ' + selectedItemMeasuring : '') +
                  (isMultipleStock &&
                  saleItem.stock_reference &&
                  selectedStockQuantity !== null
                    ? ' (Sélectionné: ' + selectedStockQuantity + ')'
                    : '')
                : '0'
            "
            disabled
            class="form-control"
          />
        </div>

        <div class="col-xl-2 col-12 my-3">
          <label>Prix d'achat TTC</label>
          <input
            :value="singlePurchasePriceTTC"
            disabled
            class="form-control"
          />
        </div>

        <div v-if="isMultipleStock" class="col-xl-3 col-12 my-3">
          <label for=""> Stock <span class="text-danger">*</span> </label>
          <select
            v-model="saleItem.stock_reference"
            class="form-select"
            :class="{
              'is-invalid':
                isMultipleStock &&
                !saleItem.stock_reference &&
                saleItem.item_reference,
            }"
          >
            <option value="">Sélectionner un stock</option>
            <option
              v-for="(stock, index) in filteredStockItems"
              :key="index"
              :value="stock.reference"
            >
              {{ stock.stockFullName }} - Quantité :
              {{ parseFloat(stock.quantity || 0).toFixed(2) }}
              {{ stock.measuring }}
            </option>
          </select>
          <div
            v-if="
              isMultipleStock &&
              !saleItem.stock_reference &&
              saleItem.item_reference &&
              filteredStockItems &&
              filteredStockItems.length > 0
            "
            class="invalid-feedback"
          >
            Veuillez sélectionner un stock
          </div>
        </div>

        <div class="col-xl-2 col-6 my-3">
          <label for="">Quantité</label>
          <input
            v-model="saleItem.quantity"
            type="text"
            :max="
              shouldShowStockQuantity && availableStockQuantity !== null
                ? parseFloat(availableStockQuantity)
                : null
            "
            step="0.01"
            :class="[
              'form-control',
              { 'is-invalid': isQuantityExceedingStock },
            ]"
            @input="validateQuantity"
          />
          <div v-if="isQuantityExceedingStock" class="invalid-feedback">
            La quantité ne peut pas dépasser le stock disponible ({{
              availableStockQuantity
            }}
            {{ selectedItemMeasuring || "" }})
          </div>
        </div>

        <div class="col-xl-2 col-6 my-3">
          <label for="">Prix U </label>
          <input v-model="saleItem.priceTTC" class="form-control" />
        </div>

        <div class="col-xl col-12 my-3">
          <label for=""> Remarque </label>
          <input v-model="saleItem.remark" class="form-control" />
        </div>
      </div>
      <br />
      <div class="row justify-content-end">
        <div class="col-auto my-3">
          <button
            type="button"
            class="btn btn-warning d-flex align-items-center"
            @click="empty()"
          >
            <i class="bi bi-arrow-clockwise fs-4 me-2"></i>
            <span> Vider </span>
          </button>
        </div>

        <div class="col-auto my-3">
          <button class="btn btn-primary" type="submit">
            <i class="bi bi-plus-circle"></i> Enregistrer
          </button>
        </div>

        <div class="col-auto my-3">
          <button
            type="button"
            class="btn btn-secondary d-flex align-items-center"
            @click="refresh()"
          >
            <i class="bi bi-arrow-clockwise fs-4 me-2"></i>
            <span> Actualiser </span>
          </button>
        </div>
      </div>
    </form>
    <br />
    <table class="table table-striped table-hover">
      <thead>
        <tr>
          <th scope="col">Nº</th>
          <th scope="col">Désignation</th>
          <th scope="col">Prix (DH*)</th>
          <th scope="col">Quantité</th>
          <th scope="col">Montant Total (DH*)</th>
          <th scope="col">Stock</th>
          <th scope="col">Remarque</th>
          <th scope="col"></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, index) in sale.sale_items" :key="index++">
          <td>
            {{ index }}
          </td>

          <td>
            <span v-if="item.itemFullName" class="text-uppercase">
              {{ item.itemFullName }}
            </span>
          </td>
          <td class="">
            <span v-if="item.priceTTC != null">
              {{ item.priceTTC }}
            </span>
          </td>
          <td class="">
            <span v-if="item.quantity != null">
              {{ item.quantity }}
            </span>
            <span v-if="item.itemMeasuring">
              {{ item.itemMeasuring }}
            </span>
          </td>
          <td class="">
            <span v-if="item.totalPriceTTC != null">
              {{ item.totalPriceTTC }}
            </span>
          </td>

          <td>
            <span v-if="item.stockFullName">
              {{ item.stockFullName }}
            </span>
          </td>

          <td>
            {{ item.remark }}
          </td>

          <td class="d-flex">
            <button @click="remove(item)" class="btn text-danger">
              <i class="bi bi-trash-fill"></i>
            </button>
            <button @click="editItem(item)" class="btn text-secondary">
              <i class="bi bi-pencil-square"></i>
            </button>
          </td>
        </tr>
      </tbody>
    </table>
    <div class="row justify-content-between">
      <div class="col text-center">
        <div class="w-auto">
          <span class="text-white bg-secondary rounded px-3 py-1">
            {{ sale.totalQuantity }}
          </span>
        </div>
      </div>

      <div class="col text-center">
        <div class="w-auto">
          <span class="text-white bg-primary rounded px-3 py-1">
            {{ sale.totalPriceTTC }}
          </span>
        </div>
      </div>

      <div class="col text-center">
        <div class="w-auto">
          <span class="text-white bg-success rounded px-3 py-1">
            {{ sale.amountPaid }}
          </span>
        </div>
      </div>

      <div class="col text-center">
        <div class="w-auto">
          <span class="text-white bg-danger rounded px-3 py-1">
            {{ sale.amountUnpaid }}
          </span>
        </div>
      </div>
    </div>

    <br>
    <br>
    <div class="row align-items-end">
      <div class="col-xl-3">
        <label for="">Client <span class="text-danger">*</span> </label>
        <vue-select
          :options="customers"
          v-model="sale.customer_reference"
          placeholder="Select an option"
          labelColumn="society"
          valueColumn="reference"
        />
      </div>

      <div class="col-auto">
        <label for="">Date <span class="text-danger">*</span></label>
        <input type="date" v-model="sale.date" class="form-control" />
      </div>
      <div class="col-auto">
        <label for="">Échéance </label>
        <input type="date" v-model="sale.deadline" class="form-control" />
      </div>
      <div class="col-auto">
        <label for="">Total </label>
        <input
          type="text"
          :disabled="!amounts_change ? true : false"
          v-model="sale.totalPriceTTC"
          class="form-control"
        />
      </div>

      <div class="col-auto">
        <label for="">Montant paye </label>
        <input
          type="text"
          :disabled="!amounts_change ? true : false"
          v-model="sale.amountPaid"
          class="form-control"
        />
      </div>

      <div class="col-auto">
        <label for="">M. reste </label>
        <input
          type="text"
          :disabled="!amounts_change ? true : false"
          v-model="sale.amountUnpaid"
          class="form-control"
        />
      </div>

      <div class="col-auto">
        <label for=""> </label>
        <input
          type="button"
          @click="
            amounts_change ? (amounts_change = false) : (amounts_change = true)
          "
          :value="amounts_change ? 'Désactiver' : 'Modifier les valeurs'"
          class="form-control bg-warning"
        />
      </div>
    </div>

    <br />
    <div class="row">
      <div class="col-12">
        <label for=""> Remarque <span class="text-danger">*</span></label>
        <textarea
          type="date"
          v-model="sale.remark"
          class="form-control"
        ></textarea>
      </div>
    </div>

    <br />
    <div class="row mt-3 justify-content-between align-items-center">
      <div class="col-8"></div>
      <div class="col-auto">
        <button class="btn btn-success" @click="saveSale(sale)">
          <i class="bi bi-check-square-fill"></i> Enregistrer les modifcations
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      saleItem: {
        item_reference: "",
        stock_reference: "",
        quantity: "",
        priceTTC: "",
        remark: "",
      },
      originalQuantity: 0,
      section_reference: null,
      item_reference: null,
      itemCode: null,
      selectedItem: {},
      disabledInput: false,
      customer_change: false,
      amounts_change: false,
    };
  },
  computed: {
    ...mapGetters("item", {
      items: "getAll",
    }),
    ...mapGetters("section", {
      sections: "getAll",
    }),
    ...mapGetters("customer", {
      customers: "getAll",
    }),
    ...mapGetters("sale", {
      saleItems: "getItems",
      totalQuantityItems: "totalQuantityItems",
      totalPriceTTCItems: "totalPriceTTCItems",
      numberItems: "numberItems",
      sale: "getSale",
    }),
    ...mapGetters("stock", {
      stockItems: "getStockItems",
    }),

    filteredStockItems() {
      if (this.saleItem.item_reference)
        return this.stockItems.filter(
          (stockItem) =>
            stockItem.item_reference == this.saleItem.item_reference
        );
      return null;
    },

    filteredItems() {
      if (this.section_reference == null) {
        return this.items;
      }

      return this.items.filter(
        (item) => item.section_reference == this.section_reference
      );
    },
    singlePurchasePriceTTC() {
      if (this.filteredStockItems && this.filteredStockItems.length === 1) {
        return this.filteredStockItems[0].purchasePriceTTC;
      }
      return "";
    },
    isMultipleStock() {
      if (this.$settings && this.$settings.stock) {
        return this.$settings.stock === "multiple";
      }
      if (this.$setting && typeof this.$setting === "function") {
        const stockValue = this.$setting("stock");
        return stockValue === "multiple";
      }
      return false;
    },
    shouldShowStockQuantity() {
      if (!this.saleItem.item_reference) {
        return false;
      }

      let stockValue = "";
      if (this.$settings && this.$settings.stock) {
        stockValue = this.$settings.stock;
      } else if (this.$setting && typeof this.$setting === "function") {
        stockValue = this.$setting("stock") || "";
      }

      return stockValue === "multiple" || stockValue === "individual";
    },
    availableStockQuantity() {
      if (!this.shouldShowStockQuantity || !this.saleItem.item_reference) {
        return null;
      }

      if (!this.filteredStockItems || this.filteredStockItems.length === 0) {
        return 0;
      }

      const totalQuantity = this.filteredStockItems.reduce((sum, stockItem) => {
        const quantity = parseFloat(stockItem.quantity) || 0;
        return sum + quantity;
      }, 0);

      let adjustedQuantity = parseFloat(totalQuantity) || 0;

      if (this.saleItem.id) {
        const originalQty = parseFloat(this.originalQuantity) || 0;
        const enteredQty = parseFloat(this.saleItem.quantity) || 0;
        adjustedQuantity = adjustedQuantity + originalQty - enteredQty;
      }

      return adjustedQuantity.toFixed(2);
    },
    selectedStockQuantity() {
      if (
        !this.isMultipleStock ||
        !this.saleItem.stock_reference ||
        !this.filteredStockItems
      ) {
        return null;
      }

      const selectedStock = this.filteredStockItems.find(
        (stock) => stock.reference === this.saleItem.stock_reference
      );

      if (selectedStock) {
        let stockQty = parseFloat(selectedStock.quantity || 0);

        if (
          this.saleItem.id &&
          this.saleItem.stock_reference === selectedStock.reference
        ) {
          const originalQty = parseFloat(this.originalQuantity) || 0;
          const enteredQty = parseFloat(this.saleItem.quantity) || 0;
          stockQty = stockQty + originalQty - enteredQty;
        }

        return stockQty.toFixed(2);
      }

      return null;
    },
    selectedItemMeasuring() {
      if (
        !this.saleItem.item_reference ||
        !this.items ||
        this.items.length === 0
      ) {
        return null;
      }

      const selectedItem = this.items.find(
        (item) => item.reference === this.saleItem.item_reference
      );
      return selectedItem && selectedItem.measuring
        ? selectedItem.measuring
        : null;
    },
    isQuantityExceedingStock() {
      if (
        !this.shouldShowStockQuantity ||
        this.availableStockQuantity === null
      ) {
        return false;
      }

      const enteredQuantity = parseFloat(this.saleItem.quantity) || 0;
      const availableQuantity = parseFloat(this.availableStockQuantity) || 0;

      return enteredQuantity > availableQuantity;
    },
  },
  methods: {
    async saveSale(data) {
      // First, check if there's a pending item update/save
      if (this.saleItem.id != null) {
        // Update existing item first
        await this.update();
      } else if (
        this.saleItem.item_reference &&
        this.saleItem.quantity &&
        this.saleItem.priceTTC
      ) {
        // Save new item first
        await this.save(this.saleItem);
      }

      // Then update the sale
      await this.$store.dispatch("sale/update", data);
      await this.refresh();
    },
    async handleFormSubmit() {
      if (this.saleItem.id != null) {
        await this.update();
      } else {
        await this.save(this.saleItem);
      }
    },
    async empty() {
      this.saleItem = {
        item_reference: "",
        stock_reference: "",
        quantity: "",
        priceTTC: "",
        remark: "",
      };
      this.originalQuantity = 0;
      this.section_reference = null;
      this.item_reference = null;
      this.itemCode = null;
      this.selectedItem = {};
      this.disabledInput = false;
    },

    validateQuantity() {
      if (this.isQuantityExceedingStock) {
        const availableQty = parseFloat(this.availableStockQuantity) || 0;
        this.saleItem.quantity = availableQty.toFixed(2);

        this.$store.dispatch(
          "notification/store",
          {
            status: "warning",
            message: `La quantité a été ajustée au stock disponible: ${availableQty}`,
          },
          { root: true }
        );
      }
    },
    async editItem(item) {
      await (this.saleItem.item_reference = item.item_reference);
      await (this.saleItem.sale_reference = this.sale.reference);
      await (this.saleItem.id = item.id);
      await (this.saleItem.quantity = item.quantity);
      await (this.saleItem.priceTTC = item.priceTTC);
      await (this.saleItem.stock_reference = item.stock_reference || "");
      await (this.saleItem.remark = item.remark || "");
      this.originalQuantity = parseFloat(item.quantity) || 0;
      await (this.disabledInput = true);
      await this.$store.dispatch("stock/fetchStocksItems");
    },

    async update() {
      if (this.isQuantityExceedingStock) {
        this.validateQuantity();
        return;
      }

      let quantity = parseFloat(this.saleItem.quantity);
      let id = this.saleItem.id;
      let sale_reference = this.saleItem.sale_reference;
      let priceTTC = parseFloat(this.saleItem.priceTTC);
      let item_reference = this.saleItem.item_reference;
      let stock_reference = this.saleItem.stock_reference || "";
      let remark = this.saleItem.remark || "";

      try {
        const updateData = {
          id,
          quantity,
          sale_reference,
          priceTTC,
          item_reference,
          stock_reference,
          remark,
        };

        await this.$store.dispatch("sale/updateItem", updateData);
        await this.refresh();
        this.empty();
        this.disabledInput = false;
      } catch (error) {
        console.error("Error updating sale item:", error);
        this.$store.dispatch(
          "notification/store",
          {
            status: "error",
            message: "Erreur lors de la mise à jour de l'article.",
          },
          { root: true }
        );
        this.disabledInput = false;
      }
    },

    async save(data) {
      if (this.isQuantityExceedingStock) {
        this.validateQuantity();
        return;
      }

      const itemToSave = data || this.saleItem;
      if (!itemToSave.sale_reference && this.sale && this.sale.reference) {
        itemToSave.sale_reference = this.sale.reference;
      }

      await this.$store.dispatch("sale/storeItem", itemToSave);

      this.saleItem.item_reference = "";
      this.saleItem.stock_reference = "";
      this.saleItem.quantity = "";
      this.saleItem.priceTTC = "";
      this.saleItem.remark = "";
      this.section_reference = null;
      this.item_reference = null;
      this.selectedItem = {};
      await this.$store.dispatch("stock/fetchStocksItems");
      await this.refresh();
    },

    async remove(data) {
      await this.$confirm({
        message:
          "Vous voulez supprimer l'article  " + (data.itemFullName || ""),
        confirmButtonText: "Oui",
        cancelButtonText: "Non",
      }).then(async (confirmed) => {
        if (confirmed) {
          await this.$store.dispatch("sale/destroyItem", data.id);
          await this.refresh();
        }
      });
    },
    async refresh() {
      await this.$store.dispatch("stock/fetchStocksItems");
      await this.$store.dispatch("sale/show", this.$route.params.reference);
      await this.$store.dispatch("section/getAll");
      await this.$store.dispatch("item/getAll");
      await this.$store.dispatch("customer/getAll");
    },
  },
  async beforeMount() {
    await this.$store.dispatch("stock/fetchStocksItems");
    await this.$store.dispatch("sale/show", this.$route.params.reference);
    await this.$store.dispatch("section/getAll");
    await this.$store.dispatch("item/getAll");
    await this.$store.dispatch("customer/getAll");
  },
  watch: {
    "saleItem.item_reference"(newValue, oldValue) {
      if (newValue !== oldValue && !this.saleItem.id) {
        this.saleItem.stock_reference = "";
        this.$store.dispatch("stock/fetchStocksItems");
      }
    },
  },
};
</script>
